import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { DiagnosticsService } from './diagnostics.service';
import { PwaUpdateService } from '../pwa/pwa-update.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    // Keep standard browser console logging
    console.error('[GlobalErrorHandler] Uncaught Angular Error:', error);

    // Chunk JS non piu' disponibile dopo un deploy: ricarica una volta invece di segnalare un crash
    if (PwaUpdateService.isChunkLoadError(error)) {
      try {
        if (this.injector.get(PwaUpdateService).recoverFromChunkError()) {
          return;
        }
      } catch (recoveryError) {
        console.error('[GlobalErrorHandler] Chunk recovery failed', recoveryError);
      }
    }

    try {
      const diagnostics = this.injector.get(DiagnosticsService);
      diagnostics.handleAutoCrash(error);
    } catch (handlerError) {
      console.error('[GlobalErrorHandler] Failed to report error via DiagnosticsService', handlerError);
    }
  }
}
